export enum InspectionMode {
  basicBim = "fullBim",
  bimPrep = "bimPrep",
  inspect = "qualityControlBim",
  progress = "monitorBim",
}

export interface InspectionModeOption {
  displayName: string,
  /** The reskinned nav's toggle is narrow, so the design shortens every label but BIM Prep's. */
  shortDisplayName: string,
  value: InspectionMode
}

// NOTE(dlb): This affects the order that the inspection modes are displayed in the UI.
const inspectionModes: Array<InspectionModeOption> = [{
  displayName: "Visual Progress",
  shortDisplayName: "Visual",
  value: InspectionMode.basicBim
}, {
  displayName: "BIM Prep",
  shortDisplayName: "BIM Prep",
  value: InspectionMode.bimPrep
}, {
  displayName: "Deviation Analysis",
  shortDisplayName: "Deviation",
  value: InspectionMode.inspect
}, {
  displayName: "Progress Reporting",
  shortDisplayName: "Progress",
  value: InspectionMode.progress
}];

export function canReviewElementsInInspectionMode(mode: InspectionMode) {
  switch (mode) {
    case InspectionMode.inspect:
    case InspectionMode.progress:
      return true;
    default:
      return false;
  }
}

export default inspectionModes;
